import { render, staticRenderFns } from "./HealthFemaleQuestion.vue?vue&type=template&id=21534db6&scoped=true"
import script from "./HealthFemaleQuestion.vue?vue&type=script&lang=js"
export * from "./HealthFemaleQuestion.vue?vue&type=script&lang=js"
import style0 from "./HealthFemaleQuestion.vue?vue&type=style&index=0&id=21534db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21534db6",
  null
  
)

/* custom blocks */
import block0 from "./HealthFemaleQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports